// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1lDNc","title":"Images90_title__2eMH8","images":"Images90_images__38DI0"};